import { JobType } from "@app/jobs";
import { ServiceBase } from "@app/shared";
import { ChartColumnEnum, GraphTypeEnum, DataPoint, PreDefinedJobStatisticsChart, UserDefinedChartParameters, UserDefinedJobStatisticsChartMetadata } from "./types";

export default class JobPerformanceService extends ServiceBase {
  public async getChartsByJobAndChartType(graphType: GraphTypeEnum, jobTypes?: JobType[]): Promise<PreDefinedJobStatisticsChart[]> {
    return this.makePost("jobperformance/job-statistics-by-job-type", { graphType, jobTypes });
  }

  public async getJobCountChart(/*jobTypes: JobType[]*/): Promise<DataPoint[]> {
    return this.makePost("jobperformance/job-count-by-job-type", {});
  }

  public async getJobTypes(): Promise<JobType[]> {
    return this.makeGet<JobType[]>("jobperformance/job-types");
  }

  public async getXAxisOptions(jobType: JobType): Promise<ChartColumnEnum[]> {
    return this.makePost<ChartColumnEnum[]>(`jobperformance/x-axis-options`, jobType);
  }

  public async getFilteringOptions(jobType: JobType): Promise<ChartColumnEnum[]> {
    return this.makePost<ChartColumnEnum[]>("jobperformance/filtering-options", jobType);
  }

  public async getAvailableCharts(): Promise<UserDefinedJobStatisticsChartMetadata[]> {
    return this.makeGet("jobperformance/available-charts");
  }

  public async getChartData(chartId: number): Promise<DataPoint[]> {
    return this.makeGet(`jobperformance/charts/${chartId}/get-data`);
  }

  public async createChart(chartParameters: UserDefinedChartParameters): Promise<UserDefinedJobStatisticsChartMetadata> {
    return this.makePost("jobperformance/create-chart", chartParameters);
  }

  public async deleteChart(chartId: number): Promise<void> {
    return this.makeDelete(`/jobperformance/charts/${chartId}/delete-chart`);
  }

  public async refreshUserDefinedChart(chartId: number): Promise<DataPoint[]> {
    return this.makePut(`jobperformance/charts/${chartId}/refresh-chart`);
  }


}